import chatimg from "../../Assest/Image/chatimg.jpeg";   // Chat UI screenshot → Chat App
import socialhub from "../../Assest/Image/social-hub.png";   // Video call UI → Social Hub (has WebRTC)
import fourimg from "../../Assest/Image/fourimg.jpg";     // Tech/digital → AWS Infrastructure & TaskBeast
import oneimg from "../../Assest/Image/SlackImage.jpg";       // People/team → Slack Collaboration
import twoimg from "../../Assest/Image/twoimg.jpg";       // Food → Food Delivery
import awsimg from "../../Assest/Image/AWSPro.png";

const projects = [
  {
    id: "chat-app",
    title: "Real-Time Chat App",
    subtitle: "One-to-One Messaging Platform",
    type: "Full-Stack",
    img: chatimg,                                          // ✓ Chat UI — perfect match
    liveLink: "https://chat-app-my-gusn.onrender.com/",
    githubLink: "https://github.com/Abhinav4005/chat-app-my",
    tags: ["React.js", "Node.js", "MongoDB", "Express.js", "Socket.io", "JWT"],
    shortDesc:
      "Real-time one-to-one chat platform where users can create accounts, sign in, find contacts, and exchange instant messages with live notifications.",
    overview:
      "A full-stack real-time messaging application built on the MERN stack with Socket.io for live communication. Users can register, authenticate, search for other users, and start private one-to-one conversations. Messages are delivered instantly via WebSocket connections, and online/offline status is tracked in real time.",
    highlights: [
      "Built real-time one-to-one messaging using Socket.io WebSocket connections",
      "Implemented user authentication with JWT — secure sign-up, login, and session management",
      "Designed contact discovery so users can search and connect with other registered users",
      "Added live message notifications and online presence indicators",
      "Persisted all messages and user data in MongoDB with Mongoose ODM",
      "Deployed full-stack app on Render with environment-based configuration",
    ],
    techDetails: [
      { label: "Frontend", value: "React.js, Context API" },
      { label: "Backend", value: "Node.js, Express.js" },
      { label: "Real-Time", value: "Socket.io (WebSockets)" },
      { label: "Database", value: "MongoDB, Mongoose" },
      { label: "Auth", value: "JWT — JSON Web Tokens" },
      { label: "Deployment", value: "Render" },
    ],
  },
  {
    id: "social-hub",
    title: "Social Hub",
    subtitle: "Full-Stack Social Media Platform",
    type: "Full-Stack",
    img: socialhub,
    liveLink: "https://social-media-frontend-sable-three.vercel.app",
    githubLink: "https://github.com/Abhinav4005/social-media",
    tags: ["React", "Node.js", "PostgreSQL", "Socket.io", "WebRTC", "Redis", "BullMQ", "Prisma"],
    shortDesc:
      "Full-stack social media platform with posts, comments, friend systems, real-time notifications, WebRTC video calling, and 24-hour story expiration via BullMQ.",
    overview:
      "Social Hub is a production-grade social media platform built to handle real-time interactions at scale. It supports the full social graph — posts, comments, likes, friend requests, and notifications — all delivered in real time via Socket.io with 500+ concurrent connections.",
    highlights: [
      "Engineered real-time chat and WebRTC video calling supporting 500+ concurrent connections",
      "Designed background job processing using BullMQ and Redis for automated 24-hour story expiration",
      "Built scalable friend system with real-time notification delivery via Socket.io",
      "Used Prisma ORM with PostgreSQL for type-safe, performant database queries",
      "Implemented Tanstack Query for optimistic UI updates and intelligent cache management",
    ],
    techDetails: [
      { label: "Frontend", value: "React.js, Tanstack Query, Tailwind CSS" },
      { label: "Backend", value: "Node.js, Express.js, Socket.io, WebRTC" },
      { label: "Database", value: "PostgreSQL, Prisma ORM, Redis" },
      { label: "Jobs", value: "BullMQ for async background processing" },
      { label: "Auth", value: "JWT-based authentication" },
    ],
  },
  {
    id: "taskbeast",
    title: "TaskBeast",
    subtitle: "AI-Driven Hospitality Automation Platform",
    type: "AI / Voice",
    img: fourimg,
    liveLink: null,
    githubLink: null,
    isClientProject: true,
    tags: ["NestJS", "React.js", "Twilio", "LiveKit", "PostgreSQL", "Redis", "OpenAI", "SIP"],
    shortDesc:
      "AI-driven hospitality automation platform with Twilio WhatsApp/SMS/call workflows, LiveKit voice AI, DTMF, SIP Trunking, and OpenAI API integration.",
    overview:
      "TaskBeast automates hospitality workflows using AI-powered voice agents and multi-channel messaging. It handles 5K+ monthly notifications via Twilio and uses LiveKit with OpenAI for intelligent voice interactions including call transfers and DTMF input.",
    highlights: [
      "Integrated Twilio APIs for WhatsApp, SMS, and call workflows supporting 5K+ monthly notifications",
      "Developed AI-driven voice automation using LiveKit, STT, TTS, and conversational LLMs",
      "Implemented DTMF, SIP Trunking, and SIP REFER for automated call transfer workflows",
      "Engineered voice pipelines using LiveKit Inference with OpenAI API fallback for reliability",
      "Built Redux Toolkit state management for complex multi-step automation flows",
    ],
    techDetails: [
      { label: "Frontend", value: "React.js, Redux Toolkit" },
      { label: "Backend", value: "NestJS, Python, Twilio APIs" },
      { label: "Voice AI", value: "LiveKit, STT, TTS, OpenAI API, DTMF, SIP" },
      { label: "Database", value: "PostgreSQL, Redis" },
      { label: "Notifications", value: "SendGrid, Twilio SMS/WhatsApp" },
    ],
  },
  {
    id: "aws-infrastructure",
    title: "AWS Infrastructure System",
    subtitle: "Cloud Provisioning & Lifecycle Automation",
    type: "Cloud / DevOps",
    img: awsimg,
    liveLink: null,
    githubLink: null,
    isClientProject: true,
    tags: ["React.js", "Node.js", "AWS EC2", "RDS/Aurora", "Lambda", "S3", "Auto Scaling", "SendGrid"],
    shortDesc:
      "EC2 provisioning system with user-defined time limits (up to 3 hours), automated lifecycle management, RDS/Aurora storage, and Lambda workflow automation.",
    overview:
      "A cloud infrastructure management system that provisions AWS EC2 instances on demand with user-defined time limits. The system enforces automated lifecycle management — instances are automatically terminated after the session expires, reducing infrastructure costs by up to 40%.",
    highlights: [
      "Built EC2 provisioning system with user-defined time limits up to 3 hours",
      "Reduced infrastructure costs by 30–40% through automated instance lifecycle management",
      "Integrated RDS/Aurora for persistent storage with automatic failover",
      "Used Lambda functions for event-driven workflow automation and cleanup",
      "Designed Auto Scaling groups to handle variable load across 5K+ users",
    ],
    techDetails: [
      { label: "Frontend", value: "React.js" },
      { label: "Backend", value: "Node.js, AWS SDK" },
      { label: "Cloud", value: "EC2, Auto Scaling, RDS/Aurora, Lambda, S3" },
      { label: "Notifications", value: "SendGrid email alerts" },
      { label: "Cost Saving", value: "30–40% reduction via lifecycle automation" },
    ],
  },
  {
    id: "slack-collaboration",
    title: "Slack-Inspired Collaboration",
    subtitle: "Team Communication Platform",
    type: "Full-Stack",
    img: oneimg,
    liveLink: null,
    githubLink: null,
    isClientProject: true,
    tags: ["React.js", "Node.js", "Slack API", "Tanstack Query", "WebSocket"],
    shortDesc:
      "Slack-like web application serving 5K+ users with threaded conversations, channel management, emoji reactions, and real-time message updates via Slack API.",
    overview:
      "A Slack-inspired team collaboration platform built on top of the Slack API, serving 5K+ users. It replicates core Slack functionality including channels, threads, emoji reactions, and real-time message delivery with a custom React frontend.",
    highlights: [
      "Developed a Slack-like web application serving 5K+ users using Slack API integrations",
      "Engineered threaded conversations, channel join/leave, emoji reactions, and message deletion",
      "Managed real-time channel-based communication and message updates",
      "Used Tanstack Query for efficient data fetching and cache synchronization",
      "Built responsive UI with smooth transitions and keyboard navigation support",
    ],
    techDetails: [
      { label: "Frontend", value: "React.js, Tanstack Query" },
      { label: "Backend", value: "Node.js, Slack API" },
      { label: "Real-Time", value: "Slack WebSocket events" },
      { label: "Users", value: "5K+ active users" },
      { label: "Features", value: "Threads, reactions, channels, DMs" },
    ],
  },
  {
    id: "food-delivery",
    title: "Food Delivery Landing",
    subtitle: "Responsive Frontend UI",
    type: "Frontend",
    img: twoimg,
    liveLink: "https://foodwebonline.netlify.app",
    githubLink: "https://github.com/Abhinav4005/LandingPage",
    tags: ["React.js", "CSS", "UI/UX", "Responsive Design"],
    shortDesc:
      "Responsive landing page for a food delivery web app with modern UI/UX design, smooth animations, and mobile-first layout.",
    overview:
      "A polished, mobile-first landing page for a food delivery application. Focused on clean UI/UX design principles, smooth CSS animations, and a fully responsive layout that works across all device sizes.",
    highlights: [
      "Built fully responsive layout with mobile-first CSS approach",
      "Implemented smooth scroll animations and micro-interactions",
      "Designed clean component hierarchy with reusable React components",
      "Optimized for performance with lazy loading and minimal bundle size",
      "Deployed on Netlify with continuous deployment from GitHub",
    ],
    techDetails: [
      { label: "Frontend", value: "React.js, CSS3" },
      { label: "Design", value: "Mobile-first, responsive grid" },
      { label: "Animations", value: "CSS keyframes, transitions" },
      { label: "Deployment", value: "Netlify" },
      { label: "Performance", value: "Lazy loading, optimized assets" },
    ],
  },
];

export default projects;
